var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#FF0000"}},[_vm._v(" horizontal nav menu ")])}
var staticRenderFns = []

export { render, staticRenderFns }